import * as React from 'react'
import { ContactFormVariant } from '../../../../functional/contact-form/types'
import styles from './reassurance.module.scss'
import Checklist from '../../../../checklist'
import { defineMessages, FormattedMessage } from 'react-intl'

const messages = defineMessages({
  newCompanyTextHeading: {
    defaultMessage: 'För nya företag',
    id: 'component.functional.contact-form.new-company.reassurance.text.heading',
  },
  newCompanyListHeading: {
    defaultMessage: 'Vi kommer inte börja fakturera dig tills något av följande inträffar:',
    id: 'component.functional.contact-form.new-company.reassurance.list.heading',
  },
  newCompanyTextLede: {
    defaultMessage:
      'Vi tar hand om all din bokföring kostnadsfritt fram tills du börjar dra in pengar. Sedan från 895 kr/mån.',
    id: 'component.functional.contact-form.new-company.reassurance.text.lede',
  },
  newCompanyListItem1: {
    defaultMessage: 'Du börjar fakturera eller sälja till kunder',
    id: 'component.functional.contact-form.new-company.reassurance.list-item-1',
  },
  newCompanyListItem2: {
    defaultMessage: 'Du kommer upp i 100 affärshändelser',
    id: 'component.functional.contact-form.new-company.reassurance.list-item-2',
  },
  newCompanyListItem3: {
    defaultMessage: 'Ditt första räkenskapsår tar slut',
    id: 'component.functional.contact-form.new-company.reassurance.list-item-3',
  },
  oldCompanyTextHeading: {
    defaultMessage: 'För etablerade förtag',
    id: 'component.functional.contact-form.old-company.reassurance.text.heading',
  },
  oldCompanyTextLede: {
    defaultMessage: 'Det är enkelt att flytta till oss, vi kan hjälpa dig med allt. Pris från 895 kr/mån',
    id: 'component.functional.contact-form.old-company.reassurance.text.lede',
  },
  oldCompanyListItem1: {
    defaultMessage: 'Ingen uppsägningstid',
    id: 'component.functional.contact-form.old-company.reassurance.list.item-1',
  },
  oldCompanyListItem2: {
    defaultMessage: '90 dagars nöjd-kund garanti',
    id: 'component.functional.contact-form.old-company.reassurance.list.item-2',
  },
  oldCompanyListItem3: {
    defaultMessage: '9/10 sänker sina kostnader direkt',
    id: 'component.functional.contact-form.old-company.reassurance.list.item-3',
  },
})

interface IReassuranceProps {
  variant: ContactFormVariant
}

const renderContent = (variant: ContactFormVariant) => {
  const content: { [key: string]: React.ReactNode } = {
    companyRecentlyStarted: (
      <div className={styles.oldCompanies}>
        <div className={styles.text}>
          <FormattedMessage tagName="h5" {...messages.newCompanyTextHeading} />
          <FormattedMessage tagName="p" {...messages.newCompanyTextLede} />
        </div>
        <div className={styles.list}>
          <FormattedMessage {...messages.newCompanyListHeading} tagName="h5" />
          <Checklist
            items={[
              <FormattedMessage key={1} {...messages.newCompanyListItem1} />,
              <FormattedMessage key={2} {...messages.newCompanyListItem2} />,
              <FormattedMessage key={3} {...messages.newCompanyListItem3} />,
            ]}
            tight
          />
        </div>
      </div>
    ),
    companyOld: (
      <div className={styles.oldCompanies}>
        <div className={styles.text}>
          <FormattedMessage tagName="h5" {...messages.oldCompanyTextHeading} />
          <FormattedMessage tagName="p" {...messages.oldCompanyTextLede} />
        </div>
        <div className={styles.list}>
          <Checklist
            items={[
              <FormattedMessage key={1} {...messages.oldCompanyListItem1} />,
              <FormattedMessage key={2} {...messages.oldCompanyListItem2} />,
              <FormattedMessage key={3} {...messages.oldCompanyListItem3} />,
            ]}
            tight
          />
        </div>
      </div>
    ),
  }

  return content[variant]
}

const Reassurance: React.FC<IReassuranceProps> = ({ variant }) => {
  const content = renderContent(variant)

  return <div className={styles.root}>{content}</div>
}

export default Reassurance
